import React, { Children, useEffect, useState } from "react";

import { StackShim } from "@fluentui/react-migration-v8-v9";

import i18n from "i18next";

import {
  Button,
  TableCellLayout,
  TableColumnDefinition,
  Text,
  createTableColumn,
} from "@fluentui/react-components";
import { IUserProduct } from "../../Models/IUserProduct";
import { baseUrl } from "../../helpers/constants";

import { getHighlightedText } from "../../Controls/HighlightedText";
import { CheckmarkRegular, DismissRegular } from "@fluentui/react-icons";

import { IUserProductMigrationRequestDto } from "../../Models/IUserProductmigrationRequestDto";
import { fetchWrapper } from "../../helpers/fetchwrapper";

interface IUserProductMigrationListColumnsProps {
  textFilter: string;
  onRefresh(): void;
}

export function UserProductMigrationListColumns(
  props: IUserProductMigrationListColumnsProps
) {
  const acceptOvertake = (id: string) => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/UserProduct/AcceptRequestOvertakeProduct?id=${id}`
      )
      .then((result) => {
        props.onRefresh();
      })
      .catch((error) => {});
  };

  const declineOvertake = (id: string) => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/UserProduct/DeclineRequestOvertakeProduct?id=${id}`
      )
      .then((result) => {
        props.onRefresh();
      })
      .catch((error) => {});
  };

  let columns: TableColumnDefinition<IUserProductMigrationRequestDto>[] = [
    //{i18n.t<string>("vorschauPic")}
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "vorschauPic",
      renderHeaderCell: () => {
        return i18n.t<string>("vorschauPic");
      },
      renderCell: (item: IUserProductMigrationRequestDto) => {
        return (
          <TableCellLayout>
            <div className="lueb-centerVertical">
              <img
                alt="Vorschau"
                src={`${baseUrl}/api/UserMedia/GetMedia?id=${
                  item.userProdukt.vorschauPicGuid
                    ? item.userProdukt.vorschauPicGuid
                    : "544b1221-8eef-4a44-adf9-7bd6a4724ea7"
                }`}
              ></img>
            </div>
          </TableCellLayout>
        );
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "systemId",
      renderHeaderCell: () => {
        return i18n.t<string>("systemId");
      },
      renderCell: (item: IUserProductMigrationRequestDto) => {
        return (
          <TableCellLayout>
            <div className="lueb-centerVertical">
              <StackShim horizontal tokens={{ childrenGap: 10 }}>
                <Text>
                  {getHighlightedText(
                    item.userProdukt.seriennummer,
                    props.textFilter
                  )}
                </Text>
              </StackShim>
            </div>
          </TableCellLayout>
        );
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "benennung",
      renderHeaderCell: () => {
        return i18n.t<string>("benennung");
      },
      renderCell: (item: IUserProductMigrationRequestDto) => {
        return (
          <TableCellLayout>
            <div className="lueb-centerVertical">
              <StackShim horizontal tokens={{ childrenGap: 10 }}>
                <Text>
                  {getHighlightedText(
                    i18n.language.includes("de")
                      ? item.userProdukt.benennungDE
                      : item.userProdukt.benennungEN,
                    props.textFilter
                  )}
                </Text>
              </StackShim>
            </div>
          </TableCellLayout>
        );
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "actions",
      renderHeaderCell: () => {
        return i18n.t<string>("actions");
      },
      renderCell: (item: IUserProductMigrationRequestDto) => {
        return (
          <TableCellLayout>
            <div className="lueb-centerVertical">
              <StackShim horizontal>
                <Button
                  icon={<CheckmarkRegular />}
                  onClick={() => {
                    acceptOvertake(item.id);
                  }}
                >
                  {i18n.t<string>("handOver")!}
                </Button>
                <Button
                  icon={<DismissRegular />}
                  onClick={() => {
                    declineOvertake(item.id);
                  }}
                >
                  {i18n.t<string>("decline")!}
                </Button>
              </StackShim>
            </div>
          </TableCellLayout>
        );
      },
    }),
  ];

  return columns;
}
